import React from "react";

const MARKERS = [
  { id: "uk", label: "United Kingdom", x: 45, y: 24, side: "right" },
  { id: "eu", label: "European Union", x: 52, y: 31, side: "right" },
  { id: "uae", label: "United Arab Emirates", x: 72, y: 46, side: "left" },
  { id: "gcc", label: "Saudi Arabia / GCC", x: 64, y: 55, side: "left" },
];

const LINKS = [
  ["uk", "eu"],
  ["eu", "gcc"],
  ["gcc", "uae"],
  ["eu", "uae"],
];

const pos = (id) => MARKERS.find((m) => m.id === id);

export const RegionMap = () => {
  return (
    <div className="relative overflow-hidden rounded-lg border border-white/10 bg-navy-900/60 aspect-[16/11]" data-testid="trust-region-map">
      <div className="absolute inset-0 grid-backdrop opacity-40" aria-hidden="true" />
      <div className="absolute inset-0 radial-fade" aria-hidden="true" />

      {/* Graticule + connectors */}
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
        {/* Faint continent silhouettes (stylised) */}
        <g className="text-primary/[0.16]" fill="currentColor">
          {/* North America */}
          <path d="M6 20 L20 16 L26 24 L22 34 L26 42 L18 52 L14 44 L16 34 L9 30 Z" />
          {/* South America */}
          <path d="M26 58 L33 54 L36 62 L33 76 L28 84 L26 74 L29 66 Z" />
          {/* Europe */}
          <path d="M44 22 L54 20 L57 28 L52 34 L46 33 L43 28 Z" />
          {/* Africa */}
          <path d="M47 40 L60 38 L64 50 L58 66 L52 72 L49 60 L46 50 Z" />
          {/* Middle East / Arabia */}
          <path d="M62 40 L72 40 L74 50 L67 56 L62 50 Z" />
          {/* Asia */}
          <path d="M60 18 L86 16 L94 26 L88 36 L78 34 L72 30 L64 30 L60 24 Z" />
          {/* South-East Asia / Oceania */}
          <path d="M82 44 L92 46 L90 56 L84 58 Z M86 66 L94 68 L92 76 L86 74 Z" />
        </g>
        {[18, 34, 50, 66, 82].map((y) => (
          <line key={`h${y}`} x1="4" y1={y} x2="96" y2={y} stroke="currentColor" className="text-primary/10" strokeWidth="0.15" strokeDasharray="1.2 1.6" />
        ))}
        {[20, 40, 60, 80].map((x) => (
          <line key={`v${x}`} x1={x} y1="6" x2={x} y2="94" stroke="currentColor" className="text-primary/10" strokeWidth="0.15" strokeDasharray="1.2 1.6" />
        ))}
        {LINKS.map(([a, b]) => {
          const p1 = pos(a); const p2 = pos(b);
          const mx = (p1.x + p2.x) / 2;
          const my = Math.min(p1.y, p2.y) - 8;
          return (
            <path key={`${a}-${b}`} d={`M ${p1.x} ${p1.y} Q ${mx} ${my} ${p2.x} ${p2.y}`} fill="none" stroke="currentColor" className="text-primary/40" strokeWidth="0.25" strokeDasharray="1.5 1.5" />
          );
        })}
      </svg>

      {/* Markers */}
      {MARKERS.map((m) => (
        <div key={m.id} className="absolute -translate-x-1/2 -translate-y-1/2" style={{ left: `${m.x}%`, top: `${m.y}%` }} data-testid={`region-marker-${m.id}`}>
          <span className="absolute inline-flex h-6 w-6 -translate-x-1/2 -translate-y-1/2 left-0 top-0 rounded-full bg-primary/30 animate-ping" />
          <span className="relative block h-2.5 w-2.5 rounded-full bg-primary ring-4 ring-primary/20" />
          <span
            className={`absolute top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md border border-border bg-card/95 px-2 py-1 text-[0.7rem] font-medium text-foreground shadow-sm ${m.side === "right" ? "left-4" : "right-4"}`}
          >
            {m.label}
          </span>
        </div>
      ))}

      <p className="absolute bottom-3 left-4 right-4 text-[0.7rem] text-muted-foreground/70">
        Illustrative — deploy in the region your data must stay in. UK · EU · UAE · KSA / GCC, or any jurisdiction you require.
      </p>
    </div>
  );
};
